import React from 'react'
import UserDetails from '../../components/registrationTrainingDays/UserDetails'

const PapeUserDetails = () => {
  return (
    <div className='w-full bg-slate-50'><UserDetails></UserDetails></div>
  )
}

export default PapeUserDetails